export const bandcampPath = 'https://ripship.bandcamp.com';
export const spotifyPath =
  'https://open.spotify.com/artist/1yx7HUETsdOE9oP6ISSVSX?si=NS-IbuAwSHaOMiOR70V1TA';
export const instagramPath = 'https://www.instagram.com/ripship_/';
export const facebookPath = 'https://www.facebook.com/ripshipband';
export const tiktokPath = 'https://www.tiktok.com/@ripship_';
export const youtubePath = 'https://www.youtube.com/@ripship_';

export const CRAWLING_CHORUS_PREORDER =
  'https://ripship.bandcamp.com/album/crawling-chorus';

//GIG LINKS
export const AKL_GIG =
  'https://www.undertheradar.co.nz/gig/100881/Ripship-Europe-Tour-Fundraiser.utr';
export const MEL_GIG =
  'https://bergybandroom.oztix.com.au/outlet/event/ad96267c-406a-476f-8801-262a68fc819c?Event=233787';
export const EU_TOUR =
  'https://www.instagram.com/p/DUP-UbmkwE2/?hl=en&img_index=1';
export const OSEES_GIG = 'https://www.moshtix.co.nz/v2/event/osees/173038';

//DEBUGGER LINKS
export const DEBUG_BANDCAMP = 'https://ripship.bandcamp.com/track/debugger';
export const DEBUG_SPOTIFY =
  'https://open.spotify.com/album/4UwXu65QYExznS7jppROfs?si=EM3nTHJzQ2OZBMFfBmc8Ag';
export const DEBUG_YOUTUBE = 'https://youtu.be/9RLCsPXFCFU?si=ISOWkbmGY6tZDfal';

//NEW MEXICO LINKS
export const NEWMEX_BANDCAMP = 'https://ripship.bandcamp.com/track/new-mexico';
export const NEWMEX_SPOTIFY =
  'https://open.spotify.com/album/64WbvlQhZHUlPLyGUfhBF2?si=xnR9E_ezT4uhrDGSAtX7hQ';
export const NEWMEX_YOUTUBE =
  'https://youtu.be/FxhAAjjoq1o?si=5gw3kp5KndzVjhUG';

//CRAWLING CHORUS
export const CRAWLING_CHORUS_BANDCAMP =
  'https://ripship.bandcamp.com/album/crawling-chorus';
export const CRAWLING_CHORUS_SPOTIFY =
  'https://open.spotify.com/album/4aJCjuhuqlQGvBQ7rPU521?si=KaTS7iWpR4OPX8INwCxxtw';
export const CRAWLING_CHORUS_YOUTUBE =
  'https://youtube.com/playlist?list=OLAK5uy_m_Gsbtwo28znyhUx_8AZzl_xgOXklcmvQ&si=QdpeL2FoPQHbtg-h';
export const BON_VOYAGE_SPOTIFY =
  'https://open.spotify.com/album/2fin8bn4kRblUfp9cikJGu?si=D4xHybkrRhWOBMfj3iEakA';
export const BON_VOYAGE_YOUTUBE =
  'https://youtube.com/playlist?list=OLAK5uy_kkpqdqEMZT-8VpDz4-0afcnobuwZprIVs&si=IGZMdm-cNT0rCocS';
